module.exports = __webpack_public_path__ + "img/the-one-palacio-da-anunciada.223c9227.jpg";